// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class PDFLineLayout {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFLineLayout {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFLineLayout(bb: flatbuffers.ByteBuffer, obj?: PDFLineLayout): PDFLineLayout {
    return (obj || new PDFLineLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFLineLayout(bb: flatbuffers.ByteBuffer, obj?: PDFLineLayout): PDFLineLayout {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFLineLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  x(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  y(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  height(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  characterWidths(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0
  }

  characterWidthsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  characterWidthsArray(): Uint16Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset
      ? new Uint16Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  static startPDFLineLayout(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addX(builder: flatbuffers.Builder, x: number) {
    builder.addFieldInt16(0, x, 0)
  }

  static addY(builder: flatbuffers.Builder, y: number) {
    builder.addFieldInt16(1, y, 0)
  }

  static addHeight(builder: flatbuffers.Builder, height: number) {
    builder.addFieldInt16(2, height, 0)
  }

  static addCharacterWidths(builder: flatbuffers.Builder, characterWidthsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, characterWidthsOffset, 0)
  }

  static createCharacterWidthsVector(builder: flatbuffers.Builder, data: number[] | Uint16Array): flatbuffers.Offset
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createCharacterWidthsVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset
  static createCharacterWidthsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint16Array | Uint8Array
  ): flatbuffers.Offset {
    builder.startVector(2, data.length, 2)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt16(data[i]!)
    }
    return builder.endVector()
  }

  static startCharacterWidthsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(2, numElems, 2)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, textOffset, 0)
  }

  static endPDFLineLayout(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 10) // character_widths
    return offset
  }

  static createPDFLineLayout(
    builder: flatbuffers.Builder,
    x: number,
    y: number,
    height: number,
    characterWidthsOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFLineLayout.startPDFLineLayout(builder)
    PDFLineLayout.addX(builder, x)
    PDFLineLayout.addY(builder, y)
    PDFLineLayout.addHeight(builder, height)
    PDFLineLayout.addCharacterWidths(builder, characterWidthsOffset)
    PDFLineLayout.addText(builder, textOffset)
    return PDFLineLayout.endPDFLineLayout(builder)
  }
}
